import { Component, Label, _decorator } from 'cc';
import SupportLanguage from '../../../../common/scripts/I18n/SupportLanguage';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';

const { ccclass, requireComponent } = _decorator;
const languageDisplayOrder: SupportLanguage[] = [SupportLanguage.ENG, SupportLanguage.TCH, SupportLanguage.SCH];
const languageDisplayKeyMap: { [value in SupportLanguage]?: string } = {
    [SupportLanguage.TCH]: '繁體中文',
    [SupportLanguage.SCH]: '简体中文',
    [SupportLanguage.ENG]: 'English',
};

@ccclass('LanguageDropdown')
@requireComponent(Dropdown)
export default class LanguageDropdown extends Component {
    private _dropdown: Dropdown<SupportLanguage> = null;

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown) as Dropdown<SupportLanguage>;
        }
        return this._dropdown;
    }

    protected onLoad() {
        this.dropdown.init(
            languageDisplayOrder,
            (displayName, selectedOption) => {
                displayName.getComponent(Label).string = languageDisplayKeyMap[selectedOption];
            },
            (node, option) => {
                node.getComponentInChildren(Label).string = languageDisplayKeyMap[option];
            },
        );
    }
}
